module.exports = __webpack_public_path__ + "img/velez.981a32a4.jpg";